import { logEvent } from '@library/utilities/userLogsEvents/userLogEvents'
import { Modal, Row, CloseCircleOutlined } from 'gokwik-ui-kit'
import Terms from '@library/images/terms.html'

type Props = {}

const TNC = ({ form, setTermsCondition, setShowTNCModal, showTNCModal, userData }) => {
    return (
        <Modal
            cancelText={'Decline'}
            okText={'I Agree'}
            centered
            // className='w-1/2'
            width={'45vw'}
            title={
                <Row className='gap-2'>
                    <CloseCircleOutlined
                        size={50}
                        onClick={() => {
                            form.setFieldValue('accept_terms_and_conditions', false)
                            setTermsCondition(false)
                            setShowTNCModal(false)
                        }}
                    />
                    <p>Terms and Condtions</p>
                </Row>
            }
            open={showTNCModal}
            closeIcon={null}
            onOk={() => {
                logEvent(
                    'basic_info_tc_agree_clicked',
                    'click',
                    'kyc',
                    userData?.userDetails?.email,
                    userData?.merchantDetails?.m_id,
                )
                form.setFieldValue('accepted_terms_and_conditions', true)
                setTermsCondition(true)
                setShowTNCModal(false)
            }}
            onCancel={() => {
                logEvent(
                    'basic_info_tc_decline_clicked',
                    'click',
                    'kyc',
                    userData?.userDetails?.email,
                    userData?.merchantDetails?.m_id,
                )
                form.setFieldValue('accepted_terms_and_conditions', false)
                setTermsCondition(false)
                setShowTNCModal(false)
            }}
        >
            <div className='max-h-[70vh] overflow-auto'>
                <div className='terms' id='terms' dangerouslySetInnerHTML={{ __html: Terms }}></div>
            </div>
        </Modal>
    )
}

export default TNC
